module.exports = __webpack_public_path__ + "img/arrow.5997a9a4.svg";